export function withNamespace(namespace) {
  return type => namespace.replace(/\/$/, "") + "/" + type;
}
